import axiosInstance from '@/shared/api/axios';
import type {
  ApiCategoriesGetItem,
  ApiCategoriesGetResponse,
  ApiCategoriesGetSubcategory,
  ApiCategoriesPostBody,
  ApiCategoriesSubcategoryPostBody,
} from '@/shared/types/api/categories';

export const apiCategoriesGet = async (): Promise<ApiCategoriesGetResponse> => {
  const { data } = await axiosInstance.get<ApiCategoriesGetResponse>('/categories');
  return data;
};

export const apiCategoriesPost = async (
  body: ApiCategoriesPostBody,
): Promise<ApiCategoriesGetItem> => {
  const { data } = await axiosInstance.post<ApiCategoriesGetItem>('/categories', body);
  return data;
};

export const apiCategoriesPut = async (
  id: string,
  body: ApiCategoriesPostBody,
): Promise<ApiCategoriesGetItem> => {
  const { data } = await axiosInstance.put<ApiCategoriesGetItem>(`/categories/${id}`, body);
  return data;
};

export const apiCategoriesDelete = async (id: string, target?: string): Promise<void> => {
  await axiosInstance.delete(`/categories/${id}`, {
    params: target ? { target } : undefined,
  });
};

export const apiCategoriesSubcategoryPost = async (
  categoryId: string,
  body: ApiCategoriesSubcategoryPostBody,
): Promise<ApiCategoriesGetSubcategory> => {
  const { data } = await axiosInstance.post<ApiCategoriesGetSubcategory>(
    `/categories/${categoryId}/subcategories`,
    body,
  );
  return data;
};

export const apiCategoriesSubcategoryPut = async (
  categoryId: string,
  subId: string,
  body: ApiCategoriesSubcategoryPostBody,
): Promise<ApiCategoriesGetSubcategory> => {
  const { data } = await axiosInstance.put<ApiCategoriesGetSubcategory>(
    `/categories/${categoryId}/subcategories/${subId}`,
    body,
  );
  return data;
};

export const apiCategoriesSubcategoryDelete = async (
  categoryId: string,
  subId: string,
  target?: string,
): Promise<void> => {
  await axiosInstance.delete(`/categories/${categoryId}/subcategories/${subId}`, {
    params: target ? { target } : undefined,
  });
};
